export default __webpack_public_path__ + "static/media/kitchen3-afterK-768w.249c4dc5.webp";